import { userRoleArr } from "@/helpers/selectOptions";
import { RouteConfig } from "vue-router";

const metaDefaults = {
  requireAuth: true,
  allowedRoles: userRoleArr
};

const userRoutes: RouteConfig[] = [
  {
    path: "/dashboard",
    component: () =>
      import(
        /* webpackChunkName: "users" */
        "@/views/user/dashboard/Dashboard.vue"
      ),
    meta: {
      ...metaDefaults,
      pageTitle: "Dashboard",
      metaTags: { title: "Dashboard" }
    }
  },
  {
    path: "/profile",
    component: () =>
      import(/* webpackChunkName: "user" */ "@/views/user/Profile.vue"),
    meta: {
      ...metaDefaults,
      pageTitle: "Profile",
      metaTags: { title: "Profile" }
    }
  },
  {
    path: "/propertychangerequest/new",
    component: () =>
      import(
        /* webpackChunkName: "change-requests" */ "@/views/shared/PropertyChangeRequest/SinglePropertyChangeRequests/EditPropertyChangeRequest.vue"
      ),
    meta: {
      pageTitle: "Policy Change Request",
      requireAuth: true,
      allowedRoles: ["agent", "admin"],
      metaTags: {
        title: "Policy Change Request"
      }
    }
  },
  {
    path: "/agencyadmin/agency",
    component: () =>
      import(
        /* webpackChunkName: "agencies" */ "@/views/agencyAdmin/AgencyAdminEditAgency.vue"
      ),
    meta: {
      pageTitle: "Edit Agency",
      requireAuth: true,
      allowedRoles: ["agencyAdmin", "subAdmin", "admin"],
      metaTags: {
        title: "Edit Agency"
      }
    }
  },
  {
    path: "/onboarding",
    component: () =>
      import(
        /* webpackChunkName: "users" */ "@/views/user/onboarding/Onboarding.vue"
      ),
    meta: {
      pageTitle: "Onboarding",
      requireAuth: true,
      allowedRoles: [
        "agent",
        "admin",
        "adjuster",
        "agencyAdmin",
        "subAdmin",
        "underwriting"
      ],
      metaTags: {
        title: "Onboarding"
      }
    }
  }
];

export default userRoutes;
